import React from 'react'
import Typography from '@material-ui/core/Typography'

export const Label = ({ className, children }) => (
  <Typography className={className}>{children}</Typography>
)
